import { useEffect, useRef } from "react";

// Ultra-thin reading-progress bar pinned to the very top of the viewport.
// Uses CSS `transform: scaleX(...)` for buttery-smooth updates without
// re-rendering React on every scroll event.

export const ReadingProgress = () => {
  const barRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    const update = () => {
      rafRef.current = null;
      const el = barRef.current;
      if (!el) return;
      const doc = document.documentElement;
      const max = (doc.scrollHeight || 1) - window.innerHeight;
      const progress = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      el.style.transform = `scaleX(${progress})`;
    };
    const onScroll = () => {
      if (rafRef.current != null) return;
      rafRef.current = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (rafRef.current != null) window.cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <div
      aria-hidden
      data-testid="reading-progress"
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-1 origin-left"
    >
      <div
        ref={barRef}
        className="h-full w-full origin-left bg-gradient-to-r from-blue-500 via-cyan-400 to-amber-400 shadow-[0_0_8px_rgba(59,130,246,0.5)]"
        style={{ transform: "scaleX(0)", transition: "transform 80ms linear" }}
      />
    </div>
  );
};

export default ReadingProgress;
